export { Heading } from './heading';
export type { Variant as HeadingVariant } from './heading';
export { h1, h2, h3, h4, h5, h6 } from './styled';
